export const scrollToErrorField = (isSmall: boolean) => {
  const errorField = document.querySelector(
    '[data-info="item-modal__error-text"]'
  );
  if (!errorField) return;

  if (!isSmall) {
    errorField.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    return;
  }

  const modalWrapper = document.querySelector(
    '[data-cy="item-modal__content"]'
  );
  if (!modalWrapper) return;

  const headerHeight = 60;
  const offsetPosition =
    errorField.getBoundingClientRect().top +
    modalWrapper.scrollTop -
    headerHeight -
    250;

  modalWrapper.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};
